import { ComponentRef, Directive, ElementRef, inject, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';

import { StatusFlagComponent } from '@shared/modules/status-flag/status-flag.component';

@Directive({
  selector: '[statusFlag]',
  standalone: false,
})
export class StatusFlagDirective implements OnInit, OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private vc = inject(ViewContainerRef);

  private compRef?: ComponentRef<StatusFlagComponent> = this.vc.createComponent(StatusFlagComponent);

  @Input()
  statusFlag?: string;

  ngOnInit(): void {
    const pos = this.el.nativeElement.style.position;
    this.el.nativeElement.style.position = !pos || pos === 'static' ? 'relative' : pos;
    this.el.nativeElement.appendChild(this.compRef.location.nativeElement);
    this.compRef.instance.flag = this.statusFlag;
  }

  ngOnDestroy(): void {
    this.compRef.destroy();
  }
}
